import * as actionTypes from './actionTypes';

export const setBetType=(type)=>({
    type:actionTypes.SET_BET_TYPE,
    payload:type
})